export const selectChildren = (data) => {
    return {
        type: 'ACTIVE_STUDENT',
        data,
    }
}
